// receives record definition props as defined in RecordDefModel.js
// if filterHidden is passed true then it filters out hidden fields (and thus empty sections) 
// before returning
// returns sections and their fields (controls)
export function getFields(recordDefProps,filterHidden) {

  if (!filterHidden) {
    return recordDefProps.data.form.sections
  }
  
  let sections = []
  recordDefProps.data.form.sections.forEach((section) => {
    if(!section.hidden) {
      let filteredControls = []
      section.controls.forEach((control) => {
        if (!control.hidden) {
          filteredControls.push(control)
        }
      })
      if (filteredControls.length) {
        section.controls = filteredControls
        sections.push(section)
      }
    }
  })
  return sections
}